import React from 'react';

var CalendarIcon = function CalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 101.281 101.297",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m34.548 3.769h-8.4v-3.36a6.718 6.718 0 0 0 -13.437 0v3.36h-13.437v-3.36a6.718 6.718 0 0 0 -6.719-6.718 6.718 6.718 0 0 0 -6.718 6.718v3.36h-13.437v-3.36a6.718 6.718 0 0 0 -6.72-6.718 6.72 6.72 0 0 0 -6.72 6.718v3.36h-8.4a8.4 8.4 0 0 0 -8.4 8.4v67.188a8.4 8.4 0 0 0 8.4 8.4h47.04a1.68 1.68 0 0 0 1.674-1.682 1.68 1.68 0 0 0 -1.674-1.68h-47.037a5.053 5.053 0 0 1 -5.04-5.038v-52.072h94.065v28.556a1.68 1.68 0 0 0 3.359 0v-43.673a8.4 8.4 0 0 0 -8.4-8.4m-18.475-3.359a3.359 3.359 0 0 1 6.718 0v10.078a3.359 3.359 0 1 1 -6.718 0zm-26.872 0a3.358 3.358 0 0 1 3.355-3.359 3.358 3.358 0 0 1 3.36 3.359v10.078a3.358 3.358 0 0 1 -3.359 3.359 3.358 3.358 0 0 1 -3.356-3.359zm-26.875 0a3.358 3.358 0 0 1 3.355-3.359 3.358 3.358 0 0 1 3.359 3.359v10.078a3.358 3.358 0 0 1 -3.359 3.359 3.358 3.358 0 0 1 -3.359-3.359zm77.263 23.517h-94.065v-11.758a5.055 5.055 0 0 1 5.04-5.04h8.4v3.359a6.721 6.721 0 0 0 6.72 6.72 6.72 6.72 0 0 0 6.718-6.72v-3.359h13.438v3.359a6.72 6.72 0 0 0 6.718 6.72 6.72 6.72 0 0 0 6.718-6.72v-3.359h13.437v3.359a6.718 6.718 0 1 0 13.437 0v-3.359h8.4a5.057 5.057 0 0 1 5.04 5.04z",
    fill: "#005099",
    transform: "translate(58.085 6.558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.548 3.769h-8.4v-3.36a6.718 6.718 0 0 0 -13.437 0v3.36h-13.437v-3.36a6.718 6.718 0 0 0 -6.719-6.718 6.718 6.718 0 0 0 -6.718 6.718v3.36h-13.437v-3.36a6.718 6.718 0 0 0 -6.72-6.718 6.72 6.72 0 0 0 -6.72 6.718v3.36h-8.4a8.4 8.4 0 0 0 -8.4 8.4v67.188a8.4 8.4 0 0 0 8.4 8.4h47.04a1.68 1.68 0 0 0 1.674-1.682 1.68 1.68 0 0 0 -1.674-1.68h-47.037a5.053 5.053 0 0 1 -5.04-5.038v-52.072h94.065v28.556a1.68 1.68 0 0 0 3.359 0v-43.673a8.4 8.4 0 0 0 -8.399-8.399zm-18.476-3.36a3.359 3.359 0 0 1 6.718 0v10.078a3.359 3.359 0 1 1 -6.718 0zm-26.872 0a3.358 3.358 0 0 1 3.355-3.359 3.358 3.358 0 0 1 3.36 3.359v10.078a3.358 3.358 0 0 1 -3.359 3.359 3.358 3.358 0 0 1 -3.356-3.359zm-26.875 0a3.358 3.358 0 0 1 3.355-3.359 3.358 3.358 0 0 1 3.359 3.359v10.078a3.358 3.358 0 0 1 -3.359 3.359 3.358 3.358 0 0 1 -3.359-3.359zm77.263 23.517h-94.065v-11.758a5.055 5.055 0 0 1 5.04-5.04h8.4v3.359a6.721 6.721 0 0 0 6.72 6.72 6.72 6.72 0 0 0 6.718-6.72v-3.359h13.438v3.359a6.72 6.72 0 0 0 6.718 6.72 6.72 6.72 0 0 0 6.718-6.72v-3.359h13.437v3.359a6.718 6.718 0 1 0 13.437 0v-3.359h8.4a5.057 5.057 0 0 1 5.04 5.04z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(58.085 6.558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.359 3.359 0 0 0 3.361 3.355h6.718a3.358 3.358 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "#005099",
    transform: "translate(42.255 44.344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.359 3.359 0 0 0 3.361 3.355h6.718a3.358 3.358 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(42.255 44.344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.359 3.359 0 0 0 3.361 3.355h6.718a3.358 3.358 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "#005099",
    transform: "translate(22.098 44.344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.359 3.359 0 0 0 3.361 3.355h6.718a3.358 3.358 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(22.098 44.344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.769 4.4a3.358 3.358 0 0 0 3.359-3.362v-5.038a3.358 3.358 0 0 0 -3.359-3.361h-6.719a3.358 3.358 0 0 0 -3.359 3.361v5.04a3.358 3.358 0 0 0 3.359 3.36zm-6.719-8.4h6.719v5.04h-6.719z",
    fill: "#005099",
    transform: "translate(80.466 49.602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.769 4.4a3.358 3.358 0 0 0 3.359-3.362v-5.038a3.358 3.358 0 0 0 -3.359-3.361h-6.719a3.358 3.358 0 0 0 -3.359 3.361v5.04a3.358 3.358 0 0 0 3.359 3.36zm-6.719-8.4h6.719v5.04h-6.719z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(80.466 49.602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.36 3.36 0 0 0 3.361 3.355h6.718a3.359 3.359 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "#005099",
    transform: "translate(42.255 59.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.36 3.36 0 0 0 3.361 3.355h6.718a3.359 3.359 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(42.255 59.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.36 3.36 0 0 0 3.361 3.355h6.718a3.359 3.359 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "#005099",
    transform: "translate(22.098 59.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.025 1.256a3.358 3.358 0 0 0 -3.359-3.356h-6.718a3.359 3.359 0 0 0 -3.361 3.356v5.044a3.36 3.36 0 0 0 3.361 3.355h6.718a3.359 3.359 0 0 0 3.359-3.355zm-10.078 0h6.719v5.044h-6.718zm0 5.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(22.098 59.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.769 0h-6.719a3.358 3.358 0 0 0 -3.359 3.359v5.041a3.358 3.358 0 0 0 3.359 3.358h6.719a3.358 3.358 0 0 0 3.359-3.358v-5.041a3.358 3.358 0 0 0 -3.359-3.359m-6.719 3.359h6.719v5.041h-6.719zm0 5.04",
    fill: "#005099",
    transform: "translate(40.153 72.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.769 0h-6.719a3.358 3.358 0 0 0 -3.359 3.359v5.041a3.358 3.358 0 0 0 3.359 3.358h6.719a3.358 3.358 0 0 0 3.359-3.358v-5.041a3.358 3.358 0 0 0 -3.359-3.359zm-6.719 3.359h6.719v5.041h-6.719zm0 5.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(40.153 72.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.256 4.4h6.719a3.358 3.358 0 0 0 3.359-3.359v-5.041a3.358 3.358 0 0 0 -3.359-3.361h-6.719a3.358 3.358 0 0 0 -3.356 3.361v5.04a3.358 3.358 0 0 0 3.356 3.36m0-8.4h6.719v5.04h-6.719z",
    fill: "#005099",
    transform: "translate(56.103 49.602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.256 4.4h6.719a3.358 3.358 0 0 0 3.359-3.359v-5.041a3.358 3.358 0 0 0 -3.359-3.361h-6.719a3.358 3.358 0 0 0 -3.356 3.361v5.04a3.358 3.358 0 0 0 3.356 3.36zm0-8.4h6.719v5.04h-6.719z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(56.103 49.602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.141a3.358 3.358 0 0 0 3.359 3.359 1.68 1.68 0 1 0 0-3.359v-5.041h6.718a1.68 1.68 0 0 0 1.68-1.679 1.68 1.68 0 0 0 -1.68-1.68h-6.718a3.358 3.358 0 0 0 -3.359 3.359z",
    fill: "#005099",
    transform: "translate(53.999 62.616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.141a3.358 3.358 0 0 0 3.359 3.359 1.68 1.68 0 1 0 0-3.359v-5.041h6.718a1.68 1.68 0 0 0 1.68-1.679 1.68 1.68 0 0 0 -1.68-1.68h-6.718a3.358 3.358 0 0 0 -3.359 3.359z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(53.999 62.616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.769 0h-6.719a3.358 3.358 0 0 0 -3.359 3.359v5.041a3.358 3.358 0 0 0 3.359 3.358h6.719a3.358 3.358 0 0 0 3.359-3.358v-5.041a3.358 3.358 0 0 0 -3.359-3.359m-6.719 3.359h6.719v5.041h-6.719zm0 5.04",
    fill: "#005099",
    transform: "translate(19.996 72.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.769 0h-6.719a3.358 3.358 0 0 0 -3.359 3.359v5.041a3.358 3.358 0 0 0 3.359 3.358h6.719a3.358 3.358 0 0 0 3.359-3.358v-5.041a3.358 3.358 0 0 0 -3.359-3.359zm-6.719 3.359h6.719v5.041h-6.719zm0 5.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(19.996 72.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.166 0a21.836 21.836 0 1 0 21.834 21.836 21.838 21.838 0 0 0 -21.834-21.836m0 40.314a18.478 18.478 0 1 1 18.477-18.478 18.477 18.477 0 0 1 -18.477 18.478",
    fill: "#005099",
    transform: "translate(71.029 57.359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.166 0a21.836 21.836 0 1 0 21.834 21.836 21.838 21.838 0 0 0 -21.834-21.836zm0 40.314a18.478 18.478 0 1 1 18.477-18.478 18.477 18.477 0 0 1 -18.477 18.478z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498",
    transform: "translate(71.029 57.359)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.73 71.977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.171.176-13.065 13.065-5.939-5.941a1.678 1.678 0 0 0 -2.354.021 1.68 1.68 0 0 0 -.019 2.354l7.124 7.125a1.678 1.678 0 0 0 2.375 0l14.253-14.248a1.68 1.68 0 0 0 -2.375-2.376",
    fill: "#005099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.171.176-13.065 13.065-5.939-5.941a1.678 1.678 0 0 0 -2.354.021 1.68 1.68 0 0 0 -.019 2.354l7.124 7.125a1.678 1.678 0 0 0 2.375 0l14.253-14.248a1.68 1.68 0 0 0 -2.375-2.376z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".498"
  })));
};

export default CalendarIcon;